<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     月份选择器
  +---------------------------------------------------------------------------------------
-->

<template>
	<el-date-picker v-model="date" class="f-month-picker" type="month" :picker-options="options" :placeholder="placeholder" :default-value="new Date()" unlink-panels value-format="timestamp" :clearable="clearable" :style="{ width: width + 'px' }" @change="handleChange" />
</template>

<script>
const today = new Date(new Date().toLocaleDateString()).getTime()
export default {
	name: 'FMonthPicker',
	props: {
		value: {
			type: Number
		},
		clearable: {
			type: Boolean,
			default: true
		},
		width: {
			type: String,
			default: '160'
		},
		disablerange: {
			type: Array,
			default () {
				return []
			}
		},
		shortcuts: {
			type: Array,
			default () {
				return []
			}
		},
		placeholder: {
			type: String,
			default: '选择月份'
		}
	},
	data () {
		var disabledDate = (date) => {
			if (this.disablerange) {
				if (this.disablerange.length === 1) {
					return date.getTime() < this.disablerange[0] * 1000
				} else {
					return date.getTime() < this.disablerange[0] * 1000 || date.getTime() > this.disablerange[1] * 1000
				}
			} else {
				return false
			}
		}
		const shortcuts = []
		const choices = [
			{ text: '上个月', num: -30 },
			{ text: '三个月前', num: -90 },
			{ text: '六个月前', num: -180 },
			{ text: '六个月前', num: -360 },
			{ text: '本月', num: 0 },
			{ text: '下个月', num: 30 },
			{ text: '三个月后', num: 90 },
			{ text: '六个月后', num: 180 },
			{ text: '六个月后', num: 360 },
		]
		if (this.shortcuts.length > 0) {
			for (const c of choices) {
				if (this.shortcuts.indexOf(c.num) > -1) {
					shortcuts.push({
						text: c.text,
						onClick (picker) {
              let date = today + 3600 * 1000 * 24 * c.num
							picker.$emit('pick', date)
						}
					})
				}
			}
		}
		if (shortcuts.length) {
			return {
				options: {
					shortcuts: shortcuts,
					disabledDate: disabledDate
				}
			}
		} else {
			return {
				options: {
					disabledDate: disabledDate
				}
			}
		}
	},
	computed: {
		date: {
			get () {
				return this.value ? this.value * 1000 : null
			},
			set (val) {
				val = parseInt(val / 1000)
				this.$emit('input', val)
			}
		}
	},
	methods: {
		handleChange (val) {
			this.$emit('change', val)
		}
	}
}
</script>

<style lang="scss" slot-scoped>
</style>
